<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><i>The</i><br/>Plausibility<br/><i>of</i> Life</h1>
<p class="subtitle"><i>Resolving Darwin’s Dilemma</i><br/></p>
<p class="author"><b>Marc W. Kirschner and John C. Gerhart</b><br/><br/><br/><br/><br/></p>
<p class="center">Illustrated by John Norton<br/><br/><br/><br/><br/></p>
<p class="center"><span class="small">Yale University Press      New Haven and London</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_title.vue?7cc25229